import { ShefErrorCode, ShefErrorCodeWithPayload } from 'common/errors/ShefErrors';
import { GraphQLFormattedError } from 'graphql';
import { ShefApiResponseError } from './ShefApiResponseError';

export const isShefApiResponseErrorWithCode = <C extends ShefErrorCode | ShefErrorCodeWithPayload>(
  error: GraphQLFormattedError,
  code: C
): error is ShefApiResponseError<C> => error.extensions?.code === code;
